module.exports = __webpack_public_path__ + "static/media/star.e1456469.svg";